// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e8NwnA {
  display: flex;
  flex: 1;
  position: relative;
  z-index: 1000;
  min-height: 519px;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AccountsPayableStateControl/AccountsPayableStateControl.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".loader {\n  display: flex;\n  flex: 1;\n  position: relative;\n  z-index: 1000;\n  min-height: 519px;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `e8NwnA`
};
module.exports = ___CSS_LOADER_EXPORT___;
